import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { color, gutter } from '../../styles/mixins';

const Host = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
    margin-bottom: ${gutter(2)};
  }
  @media ${device.desktop} {
    margin-bottom: ${gutter(2)};
  }
`;

const Container = styled.div`
  display: flex;
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  width: 240px;
  margin-right: 48px;
  flex-shrink: 0;

  color: ${color('blue60')};
  transition-property: color;
  transition-duration: ${(props) => props.theme.transition.duration};
  transition-timing-function: ${(props) => props.theme.transition.timing};

  a:hover {
    color: ${color('blue100')};
  }
`;

const Right = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

const Text = styled.div``;

const InputWrap = styled.div`
  @media ${device.desktop} {
    min-width: 422px;
  }
`;

interface LotsHeaderProps {
  search: React.ReactNode;
  button: React.ReactNode;
  text: React.ReactNode;
}

export const LotsHeader = ({ search, button, text }: LotsHeaderProps) => {
  return (
    <Host>
      <Container>
        <ButtonWrap>{button}</ButtonWrap>
        <Right>
          <Text>{text}</Text>
          <InputWrap>{search}</InputWrap>
        </Right>
      </Container>
    </Host>
  );
};
